import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "./context/CartContext";
import { AdminAuthProvider, useAdminAuth } from "./context/AdminAuthContext";
import CartDrawer from "./components/CartDrawer";
import LandingPage from "./components/LandingPage";
import BlogPage from "./components/BlogPage";
import BlogPostPage from "./components/BlogPostPage";
import FaqPage from "./components/FaqPage";
import ShopPage from "./components/ShopPage";
import ProductDetailPage from "./components/ProductDetailPage";
import CheckoutPage from "./components/CheckoutPage";
import OrderConfirmationPage from "./components/OrderConfirmationPage";
import AboutPage from "./components/AboutPage";
import ContactPage from "./components/ContactPage";
import PressPage from "./components/PressPage";
import LegalPage from "./components/LegalPage";
import { TERMS, PRIVACY } from "./data/legal";
import AdminLogin from "./components/admin/AdminLogin";
import AdminDashboard from "./components/admin/AdminDashboard";

function RequireAdmin({ children }) {
  const { isAuthed, checking } = useAdminAuth();
  if (checking) return null;
  return isAuthed ? children : <Navigate to="/admin/login" replace />;
}

function App() {
  return (
    <div className="App">
      <AdminAuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/tutorials" element={<Navigate to="/" replace />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />
              <Route path="/faq" element={<FaqPage />} />
              <Route path="/shop" element={<ShopPage />} />
              <Route path="/shop/:id" element={<ProductDetailPage />} />
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/order/:orderNumber" element={<OrderConfirmationPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/press" element={<PressPage />} />
              <Route path="/terms" element={<LegalPage doc={TERMS} />} />
              <Route path="/privacy" element={<LegalPage doc={PRIVACY} />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
            </Routes>
            <CartDrawer />
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </CartProvider>
      </AdminAuthProvider>
    </div>
  );
}

export default App;
